import ajax from "../../lib/appfuse-react/core/ajax";

const registrationService = {

    validate: async (data) => {
        const response = await ajax.post('registrations/validate', data);
        return response.data;
    },

    requestToken: async (email) => {
        const response = await ajax.get(`registrations/sendVerificationCode/${email}`);
        return response.ok;
    },

    verifyEmail: async (email, token) => {
        const response = await ajax.get(`registrations/confirmVerificationCode/${email}/${token}`);
        return response.ok;
    },

    complete: async (data) => {
        const response = await ajax.post('registrations/complete', data);
        return response.authorization;
    },

}

export default registrationService;